import React from "react";
import ContainerContent from "../Container/ContainerContent";
import { Tabs } from "antd";
import { AndroidOutlined, AppleOutlined } from "@ant-design/icons";
import ManageMain from "./buro/manage/manage.main";
import BuroMain from "./buro/buroBan/buroBanMain";

function LeasingBuroMain() {
  return (
    <ContainerContent>
      <div className="ml-2">
        <Tabs defaultActiveKey="M">
          <Tabs.TabPane tab="Manage" key="M">
            <ManageMain />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Buro Ban" key="B">
            <BuroMain />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </ContainerContent>
  );
}

export default LeasingBuroMain;
